import ToolsResponseUI from "./ToolsResponseUI";

const ToolResponseApprovalUI = ({ currentToolResults, setCurrentToolResults }) => {
  const resetStyles = `
    <style>
      .email-container {
        all: revert;
      }
      .email-container * {
        all: revert;
      }
      
    </style>
    `
  if (!currentToolResults) {
    return null;
  }

  const unApprovedToolResponses = (currentToolResults || []).filter(tool_response => !tool_response.approved);
  if (unApprovedToolResponses.length == 0) {
    return null;
  }
  const handleToolResponseApproval = (tool_call_id) => {
    setCurrentToolResults((tool_responses) => tool_responses.map(tool_response => { return tool_call_id === tool_response.tool_call_id ? { ...tool_response, approved: true } : tool_response; }
    ))
  }

  return (
    <>
      {unApprovedToolResponses.length > 0 && (
        <div className="tool-requests flex flex-col items-center justify-center space-y-6">
          {unApprovedToolResponses
            .map((toolResponse, index) => {
              const contentParsed = JSON.parse(toolResponse.content);

              const renderDefaultContent = (contentParsed) => (
                <pre className="block font-sans text-sm bg-gray-100 text-gray-700 p-4 rounded-xl border border-gray-300">
                  <strong>Content:</strong> {JSON.stringify(contentParsed, null, 2)}
                </pre>
              );

              return (
                <div
                  key={toolResponse.tool_call_id}
                  className="w-full "
                >
                  {/* Render Function Name */}
                  <ToolsResponseUI tool={toolResponse} />

                  {/* add below and test for that but call one of the above functions by writing inprompt. e..g write get my lalst 5 issues to test it */}
                  <div className="p-6 text-white pt-0 flex items-center justify-end gap-2">
                    <button
                      className="bg-zinc-800 border-zinc-700 border rounded-lg px-4 py-1 text-xs transition-transform transform duration-200 ease-in-out hover:scale-105"
                      onClick={() => handleToolResponseApproval(toolResponse.tool_call_id)}
                    >
                      AI Response
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      )}

    </>
  )
}

export default ToolResponseApprovalUI;